import { Component, EventListener, getComponentByDomNode } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { getCurrentViewport, VIEWPORT_ENTERED } from '@gondel/plugin-media-queries';
import { Overlay } from '@swisslife/patterns-base/src/organisms/overlay/js/overlay';
import { Header } from '../../../organisms/header/js/header';
import eventBus, { SLEvent } from '@swisslife/sl-event-bus/src/sl-event-bus';

enum Selectors {
	Header = '.js-o-header',
	Overlay = '.js-o-overlay',
	OverlayContent = '.js-m-login__overlay-content',
	Link = '.js-m-login__link',
}

// The @Component decorator will connect the class with `data-g-name="Login"` elements.
@Component('Login')
export class Login extends GondelJqueryComponent {
	private uxBehaviourType;
	private $header: JQuery;
	private header: Header;
	private $overlay: JQuery;
	private overlay: Overlay;

	constructor(ctx: HTMLElement, componentName: string) {
		super(ctx, componentName);
		this.bindEventBus();
	}

	public start() {
		this.$header = this.$ctx.closest(Selectors.Header);
		this.$overlay = this.$ctx.find(Selectors.Overlay);

		const currentVp = getCurrentViewport();
		this.updateUxBehaviourType(currentVp);

		if (this.$header.length === 0) {
			// tslint:disable-next-line
			return console.warn(`Use Login just within a header!`);
		} else {
			this.header = getComponentByDomNode<Header>(this.$header);
		}

		if (this.$overlay.length === 0) {
			// tslint:disable-next-line
			return console.warn(`To use login, you need to provide an overlay!`);
		} else {
			this.overlay = getComponentByDomNode<Overlay>(this.$overlay.get(0));
		}
	}

	@EventListener(VIEWPORT_ENTERED)
	public _handleViewportChangeEvent(event) {
		this.updateUxBehaviourType(event.viewport);
	}

	@EventListener('click', Selectors.Link)
	public _handleLoginClick(event) {
		event.preventDefault();
		this.handleMyProfileLinkClick();
	}

	/**
	 * Event handler for the SL Event bus when the user clicks on the my-profile-link
	 */
	private handleMyProfileLinkClick = () => {
		this.header.closeNavigationOverlay(true);
		this.header.showMetaNavOverlay(this.overlay, true, this.$ctx.find(Selectors.OverlayContent).children());
	};

	/**
	 * Update the uxBehaviourType variable
	 * @param viewport {string}			the new viewport
	 */
	private updateUxBehaviourType(viewport: string) {
		if (viewport === 'large' || viewport === 'xlarge' || viewport === 'xxlarge') {
			this.uxBehaviourType = 'large';
		} else {
			this.uxBehaviourType = 'small';
		}
	}

	/**
	 * IMPORTANT: in commit 8f836bd0a68b55af65f341d2f2f4b6cfc3ddf50e this file has
	 * the original content with a demo event-emit on the eventbus. The mentioned code
	 * might need to be reverted after the FusionWidget (login) is ready.
	 * Additionally above click-listener may be removed.
	 */
	private bindEventBus = async () => {
		const eb = await eventBus();
		eb.on(SLEvent.ProfileLinkClick, this.handleMyProfileLinkClick);
	};
}
